import "./index.css";
import React, { useState } from "react";
import generateTree from "./data";
import RecursiveComponent from "./RecursiveComponent";

interface Props {
    paths: string[][];
    onSelect: (id: string | number) => void;
    hide: string[];
}

const TreeView: React.FC<Props> = ({ paths, onSelect, hide }) => {
  const [selectedId, setSelectedId] = useState(0);
  function onSelectEvent(id: number | undefined) {
    if (typeof id !== "undefined") {
      setSelectedId(id);
      onSelect(id);
    }
  }
  return (
    <ul id="myUL">
      {generateTree(paths).map((e, i) => {
        return (
          <RecursiveComponent
            data={e}
            onSelect={onSelectEvent}
            selectedId={selectedId}
            key={i}
            hide={hide}
          />
        );
      })}
    </ul>
  );
};

export default TreeView;